import { NavLink, Outlet, Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import { LayoutDashboard, CalendarCheck, Music, FolderDown, LogOut, Shield } from 'lucide-react'
import { useAuth } from '../../context/AuthContext'
import { cn } from '../../utils/helpers'

const navItems = [
  { name: 'Home', path: '/workers', icon: LayoutDashboard, end: true },
  { name: 'My Schedule', path: '/workers/schedule', icon: CalendarCheck },
  { name: 'Songs', path: '/workers/songs', icon: Music },
  { name: 'Resources', path: '/workers/resources', icon: FolderDown },
]

const WorkersLayout = () => {
  const { signOut, userProfile, isEditor } = useAuth()
  const location = useLocation()

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top bar */}
      <header className="bg-dark text-white sticky top-0 z-40 shadow-lg">
        <div className="max-w-5xl mx-auto px-4">
          <div className="h-16 flex items-center justify-between gap-4">
            <Link to="/workers" className="flex items-center gap-3 flex-shrink-0">
              <div className="w-9 h-9 bg-gradient-to-br from-primary-600 to-secondary-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-heading font-bold text-sm">DL</span>
              </div>
              <span className="font-heading font-bold text-sm hidden sm:block">
                Workers Portal
              </span>
            </Link>

            <div className="flex items-center gap-2 min-w-0">
              <span className="text-sm text-gray-300 truncate hidden md:block">
                {userProfile?.displayName}
              </span>
              {isEditor && (
                <Link
                  to="/admin"
                  className="p-2 text-gray-300 hover:text-white hover:bg-dark-200 rounded-lg transition-colors"
                  title="Admin panel"
                >
                  <Shield className="w-5 h-5" />
                </Link>
              )}
              <button
                onClick={signOut}
                className="p-2 text-gray-300 hover:text-white hover:bg-dark-200 rounded-lg transition-colors"
                title="Sign out"
              >
                <LogOut className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Nav — horizontal, scrollable on small screens */}
          <nav className="flex gap-1 overflow-x-auto pb-2 -mb-px">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.end}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-2 px-4 py-2 rounded-t-lg text-sm font-medium whitespace-nowrap transition-colors',
                    isActive
                      ? 'bg-gray-50 text-dark-100'
                      : 'text-gray-300 hover:text-white hover:bg-dark-200'
                  )
                }
              >
                <item.icon className="w-4 h-4" />
                {item.name}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      {/* Page content */}
      <motion.main
        key={location.pathname}
        className="max-w-5xl mx-auto px-4 py-8"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Outlet />
      </motion.main>
    </div>
  )
}

export default WorkersLayout
